import { render, staticRenderFns } from "./ClientsPeriodicConsolidations.vue?vue&type=template&id=232f15e0&scoped=true"
import script from "./ClientsPeriodicConsolidations.vue?vue&type=script&lang=js"
export * from "./ClientsPeriodicConsolidations.vue?vue&type=script&lang=js"
import style0 from "./ClientsPeriodicConsolidations.vue?vue&type=style&index=0&id=232f15e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232f15e0",
  null
  
)

export default component.exports